import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { recover } from "../store/actions/homeActions";
import { Link } from "react-router-dom";

import { useHistory } from 'react-router-dom';


function Recovery(props) {
  const { recoverFN, errore, recovered } = props;
  const [username, setusername] = useState(null);

  const history = useHistory();


  const handleSubmit = (e) => {
    e.preventDefault();
   /* recoverFN(
      username,
    );*/

    history.push("/login");

  };


  return (



    <div className="mt-16">
      <div className="flex justify-center mb-3 bg-white rounded-lg">
        <div className="w-full max-w-md p-4 text-black">
          <form onSubmit={handleSubmit}>
            <div className="h-2"></div>

            <div className="flex justify-center">
              <Link to="/">
                <h1 className="text-3xl font-bold">Rabo</h1> {/* Increased logo size */}
              </Link>
            </div>
            <div className="h-10"></div>

            <h1 className="text-center text-1xl font-bold">Send me a new password:</h1>

            <div className="h-8"></div>
            <div className="mb-4">
              <div className="relative">
                <input
                  required
                  className="input block w-full p-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500" // Added padding-left to input
                  type="text"
                  placeholder="Enter your e-mail address"
                  id="username"
                  name="username"
                  onChange={(v) => {
                    setusername(v.target.value);
                  }}
                />
                <span className="absolute left-3 top-2.5 text-gray-500"> {/* Added padding to icon */}
                  <i className="fas fa-user"></i>
                </span>
              </div>
            </div>



            <div className="mb-4">
              <button
                className="w-full py-2 text-white font-semibold bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none button-main"
              >
                Send me a new password
              </button>
              <div className="h-2"></div>
            </div>


            {errore ? <p className="text-red-500">An account with this email does not exist</p> : null}
            {recovered ? <p className="text-green-500">We have sent you a new password by email! Make sure you check your spam folder.</p> : null}
          </form>


          <div className="h-1"></div>
          <hr className="p-2" />
          <p className="text-center">
            Back to <Link to="/login" className="text-black font-semibold">login</Link>.
          </p>
        </div>
      </div>
    </div>



  );
}

const mapStateToProps = (state) => {
  return {
    errore: state.auth.errore,
    recovered: state.auth.recovered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    recoverFN: (username) =>
      dispatch(recover(username)),

  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  Recovery
);
